import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"
import { ClientError } from "graphql-request"
import { getSession, signOut } from "next-auth/react"

export function extractErrorCode(error) {
  if (error instanceof ClientError) {
    return error.response?.errors?.[0].message
  }
  return error.message
}

async function handleGlobalError(error: unknown) {
  if (error instanceof ClientError) {
    const errorMessage = error.response?.errors?.[0]?.message || ""

    if (
      errorMessage.includes("unauthorized") ||
      errorMessage.includes("not-activated")
    ) {
      // Only sign out if user is currently logged in
      const session = await getSession()
      if (session) {
        signOut()
      }
      return
    }
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      handleGlobalError(error)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      handleGlobalError(error)
    },
  }),
})
